<section class="pks-bursa-hero tw-overflow-hidden tw-bg-white">
  <div class="pks-bursa-fullbleed tw-relative tw-px-0">
    <div class="pks-bursa-hero__panel">
      <div
        class="tw-mx-auto tw-grid tw-max-w-[1280px] tw-grid-cols-1 tw-items-center tw-gap-10 tw-px-6 tw-py-12 lg:tw-grid-cols-2 lg:tw-px-10 lg:tw-py-16"
      >
        <div class="tw-relative tw-z-[1]">
          <div class="tw-mb-6">
            <span
              class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-solid tw-border-divider tw-bg-white tw-px-4 tw-py-1 tw-text-xs tw-font-medium tw-text-body-dark"
            >
              SME Corporation Malaysia – Program Pemangkin Pasaran Modal
            </span>
          </div>

          <h1 class="tw-m-0 tw-text-4xl tw-font-extrabold tw-leading-tight lg:tw-text-6xl">
            <span>Tingkatkan Perniagaan Anda:</span>
            <br />
            <span class="tw-font-light tw-italic">Dari PKS ke</span>
            <span class="tw-font-extrabold tw-not-italic tw-text-[#0BA7B6]">
              Syarikat Tersenarai Awam.</span
            >
          </h1>

          <p
            class="tw-mt-6 tw-max-w-xl tw-text-[23px] tw-leading-relaxed tw-text-body-dark tw-opacity-80"
          >
            Akses modal yang anda perlukan untuk berkembang. PKS&#64;Bursa menyediakan pembiayaan,
            bimbingan, dan hala tuju untuk menyenaraikan syarikat anda di Bursa Malaysia.
          </p>

          <div class="tw-mt-8 tw-flex tw-flex-wrap tw-items-center tw-gap-3">
            <a
              class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-md tw-bg-[#C0176B] tw-px-5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-[#A41459] focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#0BA7B6] focus-visible:tw-ring-offset-2"
              href="https://forms.clickup.com/9008241541/f/8cexpw5-99476/4EH0H5XUAZ5JU08L03"
              target="_blank"
              rel="noreferrer"
            >
              Mohon Sekarang
              <span aria-hidden="true">→</span>
            </a>

            <button
              type="button"
              class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-solid tw-border-divider tw-bg-white tw-px-5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-body-dark hover:tw-bg-divider hover:tw-bg-opacity-50 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#0BA7B6] focus-visible:tw-ring-offset-2"
              (click)="scrollToRoadmap()"
            >
              Lihat Hala Tuju
              <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>

        <div></div>
      </div>
    </div>

    <div class="pks-bursa-ticker tw-w-full tw-bg-black tw-py-2">
      <div
        class="pks-bursa-ticker__track tw-flex tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-white tw-text-opacity-90"
      >
        <div class="pks-bursa-ticker__item tw-pr-10">
          Pengambilan kohort adalah terhad. Roadshow bermula Jun 2026. Daftar minat anda hari ini.
          <span class="tw-text-[#0BA7B6]">*Pemohon awal akan diutamakan*</span>
        </div>
        <div class="pks-bursa-ticker__item tw-pr-10">
          Pengambilan kohort adalah terhad. Roadshow bermula Jun 2026. Daftar minat anda hari ini.
          <span class="tw-text-[#0BA7B6]">*Pemohon awal akan diutamakan*</span>
        </div>
        <div class="pks-bursa-ticker__item tw-pr-10">
          Pengambilan kohort adalah terhad. Roadshow bermula Jun 2026. Daftar minat anda hari ini.
          <span class="tw-text-[#0BA7B6]">*Pemohon awal akan diutamakan*</span>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="pks-bursa-gateway tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-mx-auto tw-max-w-[1280px] tw-px-6 lg:tw-px-10">
      <div
        class="pks-bursa-gateway__stats tw-grid tw-grid-cols-1 tw-gap-6 tw-border-b tw-border-solid tw-border-divider tw-py-10 md:tw-grid-cols-3 md:tw-gap-0"
      >
        <div
          class="tw-text-center md:tw-border-r md:tw-border-solid md:tw-border-divider md:tw-px-6"
        >
          <div class="tw-text-3xl tw-font-extrabold tw-text-[#0BA7B6] md:tw-text-4xl">
            RM2 Juta–RM5 Juta
          </div>
          <div class="tw-mt-1 tw-text-xs tw-font-medium tw-text-body-dark tw-opacity-70">
            Kemudahan Pembiayaan
          </div>
        </div>
        <div
          class="tw-text-center md:tw-border-r md:tw-border-solid md:tw-border-divider md:tw-px-6"
        >
          <div class="tw-text-3xl tw-font-extrabold tw-text-[#0BA7B6] md:tw-text-4xl">5%</div>
          <div class="tw-mt-1 tw-text-xs tw-font-medium tw-text-body-dark tw-opacity-70">
            Kadar Tetap
          </div>
        </div>
        <div class="tw-text-center md:tw-px-6">
          <div class="tw-text-3xl tw-font-extrabold tw-text-[#0BA7B6] md:tw-text-4xl">IPO</div>
          <div class="tw-mt-1 tw-text-xs tw-font-medium tw-text-body-dark tw-opacity-70">
            Daripada tahap sedia IPO hinggalah tersenarai awam
          </div>
          <div class="tw-mt-1 tw-text-xs tw-font-medium tw-text-body-dark tw-opacity-70">
            anda disokong pada setiap langkah
          </div>
        </div>
      </div>

      <div class="tw-grid tw-grid-cols-1 tw-gap-10 tw-py-12 lg:tw-grid-cols-12 lg:tw-py-16">
        <div class="lg:tw-col-span-12">
          <h2 class="tw-m-0 tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl">
            <span>Gerbang Anda ke</span>
            <span class="tw-text-[#0BA7B6]"> Pasaran Modal</span>
          </h2>

          <div
            class="tw-mt-6 tw-max-w-none tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-80"
          >
            <p class="tw-mb-4">
              PKS&#64;Bursa ialah inisiatif strategik oleh SME Corporation Malaysia yang direka
              untuk mendorong PKS berpotensi tinggi ke arah penyenaraian awam di Bursa Malaysia.
            </p>
            <p class="tw-m-0">
              Program ini merapatkan jurang antara pemilikan swasta dan pertumbuhan awam, sekali gus
              melengkapkan pemilik perniagaan dengan alat kewangan, pengetahuan tadbir urus, dan
              sokongan institusi yang diperlukan untuk melangkah ke pasaran modal Malaysia dengan
              penuh yakin.
            </p>
          </div>

          <ul class="pks-bursa-gateway__bullets tw-mt-8 tw-space-y-3 tw-pl-0">
            <li class="tw-flex tw-items-start tw-gap-3">
              <span class="pks-bursa-gateway__check" aria-hidden="true"></span>
              <span class="tw-text-[20px] tw-text-body-dark">
                Program disokong kerajaan dengan bantuan berstruktur
              </span>
            </li>
            <li class="tw-flex tw-items-start tw-gap-3">
              <span class="pks-bursa-gateway__check" aria-hidden="true"></span>
              <span class="tw-text-[20px] tw-text-body-dark"
                >Kurangkan risiko proses IPO dengan bimbingan pakar</span
              >
            </li>
            <li class="tw-flex tw-items-start tw-gap-3">
              <span class="pks-bursa-gateway__check" aria-hidden="true"></span>
              <span class="tw-text-[20px] tw-text-body-dark"
                >Sertai komuniti perniagaan paling berprestij di Malaysia</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="pks-bursa-pillars tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-mx-auto tw-max-w-[1280px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <div class="tw-text-left">
        <h2
          class="tw-m-0 tw-text-left tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl"
        >
          <span>Semua yang Anda Perlukan</span>
          <br />
          <span class="tw-text-[#0BA7B6]">untuk Tersenarai dengan Yakin</span>
        </h2>
        <div
          class="tw-mt-3 tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.25em] tw-text-body-dark tw-opacity-50"
        >
          Tiga Teras Kejayaan
        </div>
      </div>

      <div class="pks-bursa-pillars__block tw-mt-10">
        <div class="pks-bursa-pillars__cols">
          <div class="pks-bursa-pillars__col">
            <div class="pks-bursa-pillars__pill">Teras 01</div>
            <div class="tw-mt-4 tw-text-[22px] tw-font-extrabold tw-text-body-dark">
              Modal Pertumbuhan
            </div>
            <div
              class="tw-mt-1 tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-body-dark tw-opacity-50"
            >
              Suntikan Kewangan
            </div>
            <p class="tw-mt-5 tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
              Akses pembiayaan antara RM2 juta hingga RM5 juta pada kadar tetap 5% yang kompetitif.
              Anda tidak perlu menanggung kos permulaan untuk penyenaraian anda. Modal bukan lagi
              halangan.
            </p>
            <div class="pks-bursa-pillars__metric">RM2 Juta–RM5 Juta</div>
          </div>

          <div class="pks-bursa-pillars__col">
            <div class="pks-bursa-pillars__pill">Teras 02</div>
            <div class="tw-mt-4 tw-text-[22px] tw-font-extrabold tw-text-body-dark">
              Bimbingan Penyenaraian Perniagaan
            </div>
            <div
              class="tw-mt-1 tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-body-dark tw-opacity-50"
            >
              Bimbingan Pakar
            </div>
            <p class="tw-mt-5 tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
              Anda tidak melakukan ini bersendirian. Program pembangunan kapasiti kami memadankan
              pasukan kepimpinan anda dengan pakar dalam Kecemerlangan Tadbir Urus Korporat,
              pelaporan kewangan, dan persediaan hubungan pelabur.
            </p>
            <div class="pks-bursa-pillars__metric">Mentor Berdedikasi</div>
          </div>

          <div class="pks-bursa-pillars__col">
            <div class="pks-bursa-pillars__pill">Teras 03</div>
            <div class="tw-mt-4 tw-text-[22px] tw-font-extrabold tw-text-body-dark">
              Pengiktirafan Pasaran
            </div>
            <div
              class="tw-mt-1 tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-body-dark tw-opacity-50"
            >
              Prestij Penyenaraian
            </div>
            <p class="tw-mt-5 tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
              Raih ekuiti jenama yang utuh, jana kecairan pasaran, dan buka peluang kepada pelabur
              institusi. Transformasikan syarikat anda sebagai peneraju dalam pasaran modal.
            </p>
            <div class="pks-bursa-pillars__metric">Bursa Malaysia</div>
          </div>
        </div>
      </div>

      <div class="tw-mt-10 tw-grid tw-grid-cols-1 tw-gap-4 lg:tw-grid-cols-3">
        <div class="pks-bursa-pillars__mini tw-bg-white tw-p-8">
          <img
            src="/assets/img/icons/svgs/pkspeople.svg"
            alt=""
            class="pks-bursa-pillars__mini-icon"
          />
          <div class="tw-text-[21px] tw-font-extrabold tw-text-body-dark">
            Rangkaian 50,000 Pelabur pitchIN
          </div>
          <p class="tw-mt-3 tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
            Bakal pemegang saham anda sudah berdaftar di platform ECF nombor 1 di Malaysia.
          </p>
        </div>
        <div class="pks-bursa-pillars__mini tw-bg-white tw-p-8">
          <img
            src="/assets/img/icons/svgs/pksarrow.svg"
            alt=""
            class="pks-bursa-pillars__mini-icon"
          />
          <div class="tw-text-[21px] tw-font-extrabold tw-text-body-dark">
            Akses Pasaran Sekunder PSTX
          </div>
          <p class="tw-mt-3 tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
            Satu-satunya program yang memberikan akses kepada syarikat pra-IPO bagi menembusi
            pasaran sekunder saham swasta pertama Malaysia untuk penemuan harga yang disahkan.
          </p>
        </div>
        <div class="pks-bursa-pillars__mini tw-bg-white tw-p-8">
          <img
            src="/assets/img/icons/svgs/pksbook.svg"
            alt=""
            class="pks-bursa-pillars__mini-icon"
          />
          <div class="tw-text-[21px] tw-font-extrabold tw-text-body-dark">
            Perkhidmatan Penasihat Profesional
          </div>
          <p class="tw-mt-3 tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
            Akses kepada penasihat pasaran modal berpengalaman melalui rakan penasihat kami bagi
            membimbing anda dalam tadbir urus korporat, pematuhan kewangan, hubungan pelabur, dan
            penstrukturan IPO.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
<section id="pks-bursa-roadmap" class="pks-bursa-steps tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-max-w-[1100px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <div class="pks-bursa-steps__grid tw-grid tw-grid-cols-1 tw-gap-10 lg:tw-gap-12">
        <div>
          <h2 class="tw-m-0 tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl">
            <span>Daripada Permohonan Hingga</span>
            <span class="tw-text-[#0BA7B6]"> Hari Penyenaraian</span>
          </h2>
          <p
            class="tw-mt-4 tw-max-w-xl tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
          >
            Laluan berstruktur dengan sokongan padu daripada kedudukan anda hari ini ke destinasi
            yang layak dicapai perniagaan anda.
          </p>

          <ol class="pks-bursa-steps__list tw-mt-8 tw-space-y-6 tw-pl-0">
            <li class="pks-bursa-steps__item">
              <div class="pks-bursa-steps__no">1</div>
              <div>
                <div class="pks-bursa-steps__step">Langkah 1</div>
                <div class="pks-bursa-steps__title">Permohonan</div>
                <div class="pks-bursa-steps__desc">
                  Hantar permohonan anda melalui pautan di bawah. Pasukan kami akan menyemak profil
                  anda.
                </div>
              </div>
            </li>
            <li class="pks-bursa-steps__item">
              <div class="pks-bursa-steps__no">2</div>
              <div>
                <div class="pks-bursa-steps__step">Langkah 2</div>
                <div class="pks-bursa-steps__title">Penilaian</div>
                <div class="pks-bursa-steps__desc">
                  Kami mengesahkan status PMKS dan pensijilan SCORE anda untuk memastikan kelayakan,
                  kemudian menilai kesediaan penyenaraian anda berdasarkan kriteria program bagi
                  memastikan hanya syarikat yang tepat melangkah ke hadapan.
                </div>
              </div>
            </li>
            <li class="pks-bursa-steps__item">
              <div class="pks-bursa-steps__no">3</div>
              <div>
                <div class="pks-bursa-steps__step">Langkah 3</div>
                <div class="pks-bursa-steps__title">Pembangunan Kapasiti</div>
                <div class="pks-bursa-steps__desc">
                  Modul intensif selama 12 minggu di KL merangkumi tadbir urus, pematuhan kewangan,
                  dan komunikasi pelabur.
                </div>
              </div>
            </li>
            <li class="pks-bursa-steps__item">
              <div class="pks-bursa-steps__no">4</div>
              <div>
                <div class="pks-bursa-steps__step">Langkah 4</div>
                <div class="pks-bursa-steps__title">Kesediaan Pra-IPO</div>
                <div class="pks-bursa-steps__desc">
                  Program berstruktur yang menyediakan perniagaan anda untuk penyenaraian merangkumi
                  penstrukturan semula korporat, pematuhan, penilaian wajar, dan hubungan pelabur.
                  Pasukan kami akan membimbing anda sehingga syarikat anda sedia untuk tersenarai.
                </div>
              </div>
            </li>
            <li class="pks-bursa-steps__item">
              <div class="pks-bursa-steps__no">5</div>
              <div>
                <div class="pks-bursa-steps__step">Langkah 5</div>
                <div class="pks-bursa-steps__title">Hari Penyenaraian</div>
                <div class="pks-bursa-steps__desc">
                  Bunyikan loceng. Syarikat anda kini menyertai barisan syarikat tersenarai awam
                  Malaysia.
                </div>
              </div>
            </li>
          </ol>
        </div>

        <div>
          <div class="pks-bursa-steps__art tw-mx-auto tw-max-w-[520px] lg:tw-ml-auto lg:tw-mr-0">
            <img
              src="/assets/img/banner/people-01%201.png"
              alt=""
              class="pks-bursa-steps__person"
            />
          </div>
        </div>
      </div>

      <div
        class="pks-bursa-steps__howto tw-mx-auto tw-mt-12 tw-max-w-[920px] tw-rounded-xl tw-bg-[#8A7A45] tw-p-10 tw-text-white"
      >
        <div
          class="tw-text-[20px] tw-font-semibold tw-uppercase tw-tracking-[0.25em] tw-text-white tw-text-opacity-80"
        >
          Cara Memohon:
        </div>

        <div class="tw-mt-6 tw-grid tw-grid-cols-1 tw-gap-8 lg:tw-grid-cols-3">
          <div>
            <div class="tw-text-[18px] tw-font-bold">01&nbsp; Daftarkan Minat Anda</div>
            <div class="tw-mt-2 tw-text-[16px] tw-leading-relaxed tw-text-white tw-text-opacity-80">
              Lengkapkan borang permohonan. Kongsikan tentang perniagaan, matlamat, dan tahap semasa
              anda.
            </div>
          </div>
          <div>
            <div class="tw-text-[18px] tw-font-bold">
              02&nbsp; Hadiri Roadshow atau Sesi Saringan
            </div>
            <div class="tw-mt-2 tw-text-[16px] tw-leading-relaxed tw-text-white tw-text-opacity-80">
              Kami datang kepada anda. Sertai kami di JB, Pulau Pinang, KL, Sabah atau Sarawak —
              atau minta sesi secara maya.
            </div>
          </div>
          <div>
            <div class="tw-text-[18px] tw-font-bold">03&nbsp; Dipilih</div>
            <div class="tw-mt-2 tw-text-[16px] tw-leading-relaxed tw-text-white tw-text-opacity-80">
              Syarikat yang disenarai pendek akan menyertai kohort Pre-IPO Accelerator kami bermula
              September 2026.
            </div>
          </div>
        </div>

        <div class="tw-mt-8 tw-grid tw-grid-cols-1 tw-items-end tw-gap-6 lg:tw-grid-cols-2">
          <div class="tw-text-[16px] tw-text-white tw-text-opacity-80">
            <div class="tw-font-bold">Permohonan untuk kohort 2026 kini dibuka.</div>
            <div class="tw-text-white tw-text-opacity-60">
              Pengambilan adalah terhad – pemohon awal diutamakan.
            </div>
          </div>

          <div class="tw-flex lg:tw-justify-end">
            <a
              class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-md tw-bg-[#0BA7B6] tw-px-6 tw-py-3 tw-text-sm tw-font-semibold tw-text-white hover:tw-opacity-90 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#0BA7B6] focus-visible:tw-ring-offset-2"
              href="https://forms.clickup.com/9008241541/f/8cexpw5-99476/4EH0H5XUAZ5JU08L03"
              target="_blank"
              rel="noreferrer"
            >
              Mohon Sekarang
              <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="pks-bursa-ready tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-max-w-[1280px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <div class="pks-bursa-ready__header tw-max-w-[920px]">
        <h2
          class="tw-m-0 tw-text-left tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl"
        >
          <span>Adakah Anda</span>
          <span class="tw-text-[#0BA7B6]"> Bersedia untuk Tersenarai?</span>
        </h2>
        <p
          class="tw-mt-4 tw-w-full tw-text-left tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
        >
          Tandakan semua kotak untuk kelayakan kendiri. Jika anda boleh menandakan setiap item di
          bawah, PKS&#64;Bursa dibina untuk anda.
        </p>
      </div>

      <div
        class="pks-bursa-ready__grid tw-mt-10 tw-grid tw-max-w-[920px] tw-grid-cols-1 tw-gap-10 lg:tw-gap-12"
      >
        <div class="tw-w-full tw-space-y-3 lg:tw-max-w-[520px]">
          <div class="pks-bursa-ready__card tw-bg-white tw-p-5">
            <div class="tw-flex tw-gap-4">
              <div class="pks-bursa-ready__no">01</div>
              <div class="tw-min-w-0">
                <div class="tw-text-[20px] tw-font-extrabold tw-text-body-dark">
                  Status PMKS — PMKS Malaysia yang Disahkan
                </div>
                <div
                  class="tw-mt-1 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
                >
                  Perniagaan anda mesti sebuah PMKS Malaysia yang berdaftar dan disahkan.
                </div>
                <a
                  class="pks-bursa-ready__link"
                  href="https://mybpi.smecorp.gov.my/Registration/index.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  Mohon atau sahkan di sini <span aria-hidden="true">→</span>
                </a>
              </div>
            </div>
          </div>

          <div class="pks-bursa-ready__card tw-bg-white tw-p-5">
            <div class="tw-flex tw-gap-4">
              <div class="pks-bursa-ready__no">02</div>
              <div class="tw-min-w-0">
                <div class="tw-text-[20px] tw-font-extrabold tw-text-body-dark">
                  Penarafan Bintang SCORE — 3 Bintang ke atas
                </div>
                <div
                  class="tw-mt-1 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
                >
                  Perniagaan anda mesti mempunyai penarafan SCORE sekurang-kurangnya 3 bintang
                  daripada SME Corp. Malaysia.
                </div>
                <a
                  class="pks-bursa-ready__link"
                  href="https://mybpi.smecorp.gov.my/Registration/index.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  Mohon di sini. <span aria-hidden="true">→</span>
                </a>
              </div>
            </div>
          </div>

          <div class="pks-bursa-ready__card tw-bg-white tw-p-5">
            <div class="tw-flex tw-gap-4">
              <div class="pks-bursa-ready__no pks-bursa-ready__no--muted">03</div>
              <div class="tw-min-w-0">
                <div class="tw-text-[20px] tw-font-extrabold tw-text-body-dark">
                  Rekod Prestasi yang Kukuh
                </div>
                <div
                  class="tw-mt-1 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
                >
                  Rekod prestasi operasi yang terbukti dan kedudukan kewangan yang jelas.
                </div>
              </div>
            </div>
          </div>

          <p class="tw-mt-5 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-60">
            Program PKS&#64;Bursa direka khusus untuk PKS yang telah membuktikan kecemerlangan
            melalui pensijilan SCORE dan pendaftaran PMKS mereka. Jika anda memenuhi kriteria ini,
            anda bersedia untuk mengambil langkah seterusnya.
          </p>

          <a
            class="tw-mt-4 tw-inline-flex tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-rounded-md tw-bg-[#C0176B] tw-px-6 tw-py-3 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-[#A41459] focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#0BA7B6] focus-visible:tw-ring-offset-2"
            href="https://forms.clickup.com/9008241541/f/8cexpw5-99476/4EH0H5XUAZ5JU08L03"
            target="_blank"
            rel="noreferrer"
          >
            Mohon Sekarang
            <span aria-hidden="true">→</span>
          </a>
        </div>

        <div class="pks-bursa-ready__side">
          <div class="pks-bursa-ready__panel tw-rounded-xl tw-bg-[#0BA7B6] tw-p-7 tw-text-white">
            <div class="tw-text-[20px] tw-font-extrabold">Masih ragu tentang kelayakan anda?</div>
            <p class="tw-mt-2 tw-text-[20px] tw-leading-relaxed tw-text-white tw-text-opacity-90">
              Jom semak kesediaan perniagaan anda bersama pasukan kami di siri jelajah terdekat
              secara percuma, tanpa komitmen.
            </p>

            <div class="tw-mt-6 tw-text-[20px] tw-font-extrabold">Tarikh Roadshow</div>
            <ul class="tw-mt-4 tw-space-y-3 tw-pl-0">
              <li class="tw-flex tw-items-center tw-justify-between tw-text-[16px]">
                <a
                  class="tw-flex tw-w-full tw-items-center tw-justify-between tw-text-white tw-no-underline hover:tw-text-white hover:tw-underline focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-white focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-[#0BA7B6]"
                  href="https://luma.com/fzeylv7q"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span class="tw-flex tw-items-center tw-gap-2">
                    <span class="pks-bursa-ready__dot" aria-hidden="true"></span>
                    Johor Bahru
                  </span>
                  <span class="tw-whitespace-nowrap tw-text-white tw-text-opacity-80"
                    >30 Jun, Selasa</span
                  >
                </a>
              </li>
              <li class="tw-flex tw-items-center tw-justify-between tw-text-[16px]">
                <a
                  class="tw-flex tw-w-full tw-items-center tw-justify-between tw-text-white tw-no-underline hover:tw-text-white hover:tw-underline focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-white focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-[#0BA7B6]"
                  href="https://luma.com/30118sac?tk=TzwfPF"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span class="tw-flex tw-items-center tw-gap-2">
                    <span class="pks-bursa-ready__dot" aria-hidden="true"></span>
                    Pulau Pinang
                  </span>
                  <span class="tw-whitespace-nowrap tw-text-white tw-text-opacity-80">24 Julai, Jumaat</span>
                </a>
              </li>
              <li class="tw-flex tw-items-center tw-justify-between tw-text-[16px]">
                <span class="tw-flex tw-items-center tw-gap-2">
                  <span class="pks-bursa-ready__dot" aria-hidden="true"></span>
                  Kuala Lumpur
                </span>
                <span class="tw-whitespace-nowrap tw-text-white tw-text-opacity-80">Tarikh: TBC</span>
              </li>
              <li class="tw-flex tw-items-center tw-justify-between tw-text-[16px]">
                <span class="tw-flex tw-items-center tw-gap-2">
                  <span class="pks-bursa-ready__dot" aria-hidden="true"></span>
                  Kota Kinabalu
                </span>
                <span class="tw-whitespace-nowrap tw-text-white tw-text-opacity-80"
                  >6 Ogos, Khamis</span
                >
              </li>
              <li class="tw-flex tw-items-center tw-justify-between tw-text-[16px]">
                <span class="tw-flex tw-items-center tw-gap-2">
                  <span class="pks-bursa-ready__dot" aria-hidden="true"></span>
                  Kuching
                </span>
                <span class="tw-whitespace-nowrap tw-text-white tw-text-opacity-80"
                  >10 Ogos, Isnin</span
                >
              </li>
            </ul>
          </div>

          <div class="pks-bursa-ready__art tw-relative">
            <img
              src="/assets/img/banner/people-02%201.png"
              alt=""
              class="pks-bursa-ready__person"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="pks-bursa-compare tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-mx-auto tw-max-w-[1280px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <h2 class="tw-m-0 tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl">
        <span>Kehidupan Sebelum Penyenaraian</span>
        <br />
        <span class="tw-text-[#0BA7B6]"> vs. Selepas Penyenaraian</span>
      </h2>

      <div
        class="tw-mt-10 tw-overflow-x-auto tw-rounded-xl tw-border tw-border-solid tw-border-divider tw-bg-white"
      >
        <table class="tw-w-full tw-min-w-[820px] tw-border-collapse">
          <thead>
            <tr class="tw-bg-[#f3f4f6]">
              <th
                class="tw-w-[22%] tw-px-6 tw-py-4 tw-text-left tw-text-[16px] tw-font-extrabold tw-uppercase tw-tracking-[0.2em] tw-text-body-dark tw-opacity-60"
              >
                Aspek
              </th>
              <th
                class="tw-w-[39%] tw-px-6 tw-py-4 tw-text-left tw-text-[16px] tw-font-extrabold tw-uppercase tw-tracking-[0.2em] tw-text-body-dark tw-opacity-60"
              >
                Sebelum Penyenaraian
              </th>
              <th
                class="tw-w-[39%] tw-px-6 tw-py-4 tw-text-left tw-text-[16px] tw-font-extrabold tw-uppercase tw-tracking-[0.2em] tw-text-body-dark tw-opacity-60"
              >
                SELEPAS PENYENARAIAN
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="tw-border-t tw-border-solid tw-border-divider">
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-semibold tw-text-body-dark">
                Akses Modal
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#C0176B]">
                Terhad kepada pinjaman bank &amp; simpanan peribadi
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#0BA7B6]">
                Akses kepada pasaran modal ekuiti dan pelabur institusi
              </td>
            </tr>
            <tr class="tw-border-t tw-border-solid tw-border-divider">
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-semibold tw-text-body-dark">
                Pengiktirafan Jenama
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#C0176B]">
                Pendedahan di pasaran tempatan atau daerah
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#0BA7B6]">
                Pendedahan peringkat nasional di Bursa Malaysia
              </td>
            </tr>
            <tr class="tw-border-t tw-border-solid tw-border-divider">
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-semibold tw-text-body-dark">
                Tadbir Urus Korporat
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#C0176B]">
                Proses tidak formal, penyeliaan manual
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#0BA7B6]">
                Rangka kerja tadbir urus bertaraf antarabangsa
              </td>
            </tr>
            <tr class="tw-border-t tw-border-solid tw-border-divider">
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-semibold tw-text-body-dark">
                Nilai Pemegang Saham
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#C0176B]">
                Pemilikan swasta tidak cair
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#0BA7B6]">
                Saham boleh didagangkan dengan penilaian berdasarkan pasaran
              </td>
            </tr>
            <tr class="tw-border-t tw-border-solid tw-border-divider">
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-semibold tw-text-body-dark">
                Rangkaian Pelabur
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#C0176B]">
                Terhad kepada rangkaian peribadi
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#0BA7B6]">
                Pendedahan kepada komuniti pelabur institusi &amp; runcit
              </td>
            </tr>
            <tr class="tw-border-t tw-border-solid tw-border-divider">
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-semibold tw-text-body-dark">
                Kredibiliti Perniagaan
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#C0176B]">
                Diiktiraf sebagai PKS swasta
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#0BA7B6]">
                Diiktiraf sebagai syarikat tersenarai awam
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<section class="pks-bursa-faq tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-mx-auto tw-max-w-[1280px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <h2 class="tw-m-0 tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl">
        <span>Soalan</span>
        <span class="tw-text-[#0BA7B6]"> Lazim</span>
      </h2>

      <div class="tw-mt-10 tw-grid tw-grid-cols-1 tw-gap-10 lg:tw-grid-cols-2 lg:tw-gap-14">
        <div class="tw-space-y-10">
          <div class="pks-bursa-faq__item">
            <div class="pks-bursa-faq__q">Apakah itu PKS&#64;Bursa?</div>
            <div class="pks-bursa-faq__a">
              Program kebangsaan PKS-ke-IPO oleh SME Corp. Malaysia, dilaksanakan oleh pitchIN,
              direka untuk membawa perniagaan berpotensi tinggi ke penyenaraian di Bursa Malaysia.
            </div>
          </div>

          <div class="pks-bursa-faq__item">
            <div class="pks-bursa-faq__q">Apakah pembiayaan yang tersedia?</div>
            <div class="pks-bursa-faq__a">
              Syarikat terpilih boleh mengakses pembiayaan pada kadar tetap 5%.
            </div>
          </div>

          <div class="pks-bursa-faq__item">
            <div class="pks-bursa-faq__q">Berapa lama program ini berlangsung?</div>
            <div class="pks-bursa-faq__a">
              Fasa 1 (Accelerator) adalah 12 minggu. Fasa 2 (Kesediaan IPO) adalah 12–36 bulan
              bergantung pada tahap syarikat anda. Fasa 3 berterusan sehingga hari penyenaraian.
            </div>
          </div>
        </div>

        <div class="tw-space-y-10">
          <div class="pks-bursa-faq__item">
            <div class="pks-bursa-faq__q">Adakah saya perlu berada di KL?</div>
            <div class="pks-bursa-faq__a">
              Tidak. Kami mengadakan roadshow di JB, Pulau Pinang, KL, Sabah dan Sarawak pada 2026,
              dengan lebih banyak bandar akan datang pada 2027.
            </div>
          </div>

          <div class="pks-bursa-faq__item">
            <div class="pks-bursa-faq__q">Apakah perbezaan PKS&#64;Bursa dengan program lain?</div>
            <div class="pks-bursa-faq__a">
              Kebanyakan program menyediakan anda untuk IPO. PKS&#64;Bursa membawa anda ke sana
              dengan modal sebenar, pasaran sekunder untuk penemuan harga, dan pasukan penasihat
              yang bersama anda hingga hari penyenaraian.
            </div>
          </div>

          <div class="pks-bursa-faq__item">
            <div class="pks-bursa-faq__q">Siapa yang saya perlu hubungi?</div>
            <div class="pks-bursa-faq__a">
              Kunjungi salah satu roadshow kami atau hubungi kami di
              <a class="pks-bursa-faq__link" href="mailto:pksbursa@pitchin.my">
                pksbursa&#64;pitchin.my
              </a>
              . Anda juga boleh WhatsApp kami di
              <a
                class="pks-bursa-faq__link"
                href="https://wa.me/60102108074"
                target="_blank"
                rel="noreferrer"
              >
                +6010 210 8074
              </a>
              .
            </div>
          </div>
        </div>
      </div>

      <div class="pks-bursa-faq__art tw-mx-auto tw-mt-14 tw-max-w-[640px]">
        <img src="/assets/img/banner/people-03%201.png" alt="" class="pks-bursa-faq__people" />
      </div>
    </div>
  </div>
</section>

<section class="pks-bursa-case tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-mx-auto tw-max-w-[1280px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <div class="tw-w-full tw-text-left">
        <h2 class="tw-m-0 tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl">
          <span>Masa untuk Tersenarai adalah</span>
          <span class="tw-text-[#0BA7B6]"> Sekarang</span>
        </h2>
        <p
          class="tw-mt-4 tw-max-w-full tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
        >
          PKS&#64;Bursa direka untuk mengurangkan risiko proses IPO dan merapatkan jurang antara
          pemilikan swasta dan pertumbuhan awam bagi PKS paling berpotensi di Malaysia.
        </p>
      </div>

      <div class="tw-mt-10 tw-grid tw-w-full tw-grid-cols-1 tw-gap-4 md:tw-grid-cols-3">
        <div class="tw-rounded-xl tw-border tw-border-solid tw-border-divider tw-bg-white tw-p-7">
          <div
            class="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#0BA7B6] tw-bg-opacity-10"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#0BA7B6"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
            </svg>
          </div>
          <div class="tw-mt-5 tw-text-[20px] tw-font-extrabold tw-text-[#0BA7B6]">
            Halangan Lebih Rendah
          </div>
          <p class="tw-mt-3 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
            PKS&#64;Bursa membantu menanggung kos awal dan kerumitan untuk menjadi syarikat awam.
            Kami mengurangkan risiko proses IPO supaya anda boleh fokus pada pertumbuhan.
          </p>
        </div>

        <div class="tw-rounded-xl tw-border tw-border-solid tw-border-divider tw-bg-white tw-p-7">
          <div
            class="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#0BA7B6] tw-bg-opacity-10"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#0BA7B6"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M4 19v-7"></path>
              <path d="M12 19V5"></path>
              <path d="M20 19v-11"></path>
            </svg>
          </div>
          <div class="tw-mt-5 tw-text-[20px] tw-font-extrabold tw-text-[#0BA7B6]">
            Pertumbuhan Berstruktur
          </div>
          <p class="tw-mt-3 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
            Selaraskan sistem dalaman anda dengan piawaian korporat antarabangsa. Kami sediakan hala
            tujunya – anda laksanakan visinya.
          </p>
        </div>

        <div class="tw-rounded-xl tw-border tw-border-solid tw-border-divider tw-bg-white tw-p-7">
          <div
            class="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#0BA7B6] tw-bg-opacity-10"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#0BA7B6"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <circle cx="12" cy="8" r="3"></circle>
              <path d="M19 21H5a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4z"></path>
            </svg>
          </div>
          <div class="tw-mt-5 tw-text-[20px] tw-font-extrabold tw-text-[#0BA7B6]">
            Pengiktirafan Pasaran
          </div>
          <p class="tw-mt-3 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
            Sertai senarai syarikat terbaik di Bursa Malaysia. Jadilah sebahagian daripada kisah
            pertumbuhan ekonomi negara.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="pks-bursa-join tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-mx-auto tw-max-w-[1280px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <div class="tw-text-center">
        <h2 class="tw-m-0 tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl">
          Bersedia untuk Menyertai Bursa Malaysia?
        </h2>
        <p
          class="tw-mx-auto tw-mt-4 tw-max-w-xl tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
        >
          Mohon hari ini dan bawa perniagaan anda ke peringkat seterusnya. Pasukan kami akan
          membimbing anda dari permohonan pertama hingga ke hari penyenaraian.
        </p>

        <div
          class="tw-mt-8 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 sm:tw-flex-row"
        >
          <a
            class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-md tw-bg-[#C0176B] tw-px-6 tw-py-3 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-[#A41459] focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#0BA7B6] focus-visible:tw-ring-offset-2"
            href="https://forms.clickup.com/9008241541/f/8cexpw5-99476/4EH0H5XUAZ5JU08L03"
            target="_blank"
            rel="noreferrer"
          >
            Mohon Sekarang
            <span aria-hidden="true">→</span>
          </a>
          <a
            class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-solid tw-border-[#C0176B] tw-bg-transparent tw-px-6 tw-py-3 tw-text-sm tw-font-semibold tw-text-[#C0176B] hover:tw-bg-[#C0176B] hover:tw-text-white focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#0BA7B6] focus-visible:tw-ring-offset-2"
            href="https://smecorp.gov.my/"
            target="_blank"
            rel="noreferrer"
          >
            Lawati SME Corp
            <span aria-hidden="true">↗</span>
          </a>
        </div>

        <div class="tw-mt-8 tw-text-xs tw-text-body-dark tw-opacity-70">
          Pertanyaan? Hubungi kami di
          <a
            class="pks-bursa-faq__link tw-font-semibold"
            href="https://wa.me/60102108074"
            target="_blank"
            rel="noreferrer"
          >
            +6010 210 8074
          </a>
        </div>
      </div>

      <div
        class="pks-bursa-join__footer tw-mt-12 tw-border-t tw-border-solid tw-border-divider tw-pt-10"
      >
        <div class="tw-grid tw-grid-cols-1 tw-gap-10 lg:tw-grid-cols-12 lg:tw-items-center">
          <div class="lg:tw-col-span-3">
            <div class="tw-text-xs tw-leading-relaxed tw-text-body-dark tw-opacity-60">
              PKS&#64;Bursa adalah program oleh SME Corporation Malaysia, dilaksanakan secara rasmi
              oleh pitchIN (Pitch Platforms Sdn Bhd), platform pendanaan awam ekuiti berlesen
              Suruhanjaya Sekuriti Malaysia.
            </div>
          </div>

          <div class="lg:tw-col-span-6">
            <div
              class="tw-mx-auto tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-6 md:tw-max-w-[520px] md:tw-flex-row md:tw-justify-center md:tw-gap-20"
            >
              <div class="tw-flex tw-min-h-[110px] tw-flex-col tw-items-center tw-py-2">
                <div
                  class="tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.25em] tw-text-body-dark tw-opacity-50"
                >
                  Program oleh
                </div>
                <div class="tw-flex tw-flex-1 tw-items-center tw-justify-center">
                  <img
                    src="/assets/img/banner/logo_SME%205.png"
                    alt="SME Corp"
                    class="tw-h-[46px] tw-w-auto tw-object-contain"
                    loading="lazy"
                  />
                </div>
              </div>

              <div class="tw-flex tw-min-h-[110px] tw-flex-col tw-items-center tw-py-2">
                <div
                  class="tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.25em] tw-text-body-dark tw-opacity-50"
                >
                  Rakan Pelaksana Program
                </div>
                <div class="tw-flex tw-flex-1 tw-items-center tw-justify-center">
                  <img
                    src="/assets/img/banner/pitchin-logo%201.png"
                    alt="pitchIN"
                    class="tw-h-[68px] tw-w-auto tw-object-contain"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="lg:tw-col-span-3 lg:tw-text-right">
            <div class="tw-space-y-1 tw-text-xs tw-text-body-dark tw-opacity-80">
              <div>
                E-mel:
                <a class="pks-bursa-faq__link" href="mailto:pksbursa@pitchin.my"
                  >pksbursa&#64;pitchin.my</a
                >
              </div>
              <div>
                Telefon:
                <a
                  class="pks-bursa-faq__link"
                  href="https://wa.me/60102108074"
                  target="_blank"
                  rel="noreferrer"
                >
                  +6010 210 8074
                </a>
              </div>
              <div class="tw-text-body-dark tw-opacity-60">
                Roadshow: JB · Penang · KL · KK · Kuching
              </div>
            </div>
          </div>
        </div>

        <div
          class="tw-mt-10 tw-border-t tw-border-solid tw-border-divider tw-pt-6 tw-text-center tw-text-[11px] tw-text-body-dark tw-opacity-50"
        >
          © 2026 PKS&#64;Bursa · SME Corporation Malaysia &amp; pitchIN · Semua hak terpelihara
        </div>
      </div>
    </div>
  </div>
</section>
